export * from "-!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=8ccf484c"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=template&id=8ccf484c
// module id = null
// module chunks = 